
import ResponsiveTable from "../../../components/ResponsiveTable";
import PillLabel from "../../../components/PillLabel";
import { hideLoading, showLoading } from "../../../loading";
import request from "../../../request";
import swal from 'sweetalert';
import { Button, Menu } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import { errorToast } from "../../../toast";
import DateTime from "../../../components/DateTime";
import StyledLink from "../../../components/StyledLink";
import links from "../../../links";
import { USER_ROLE } from "../../../../../shared/constants";
import { hasIntersection } from "../../../../../shared/utils";
import { connect } from "react-redux";
import NavigationStateSaver from "../../../components/NavigationStateSaver";


class _Tokens extends NavigationStateSaver {

   state = {
      tokens: null,
      total: 0,
      page: 0,
      limit: 10,
      markers: null,
      selectedToken: null,
      addTokenMenuAnchor: null,
      filters: {
         sent: undefined,
         generated: undefined,
         from: undefined,
         to: undefined
      }
   }

   openAddTokenMenu = (addTokenMenuAnchor, selectedToken) => {
      this.setState({ addTokenMenuAnchor, selectedToken });
   }

   closeAddTokenMenu = () => {
      this.setState({ addTokenMenuAnchor: null, selectedToken: null });
   }

   fetchTokens = async () => {

      try {

         showLoading();

         const { page, limit } = this.state;
         const params = {
            page: page + 1,
            limit
         }

         const { sent, generated, from, to } = this.state.filters;
         if (typeof sent === 'boolean') params.sent = sent;
         if (typeof generated === 'boolean') params.generated = generated;
         if (from) params.from = from;
         if (to) params.to = to;

         const res = await request.get('/api/general/tokens', { params });
         const { tokens, total } = res.data;

         this.setState({ tokens, total });

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   submitToken = async () => {

      // validate
      const txtToken = document.getElementById('txt-token');
      const token = txtToken.value;

      if (!token) {
         errorToast('Token is required');
         return txtToken.focus();
      }

      try {

         const { selectedToken } = this.state;
         const tokenId = selectedToken._id;

         showLoading();

         const res = await request.patch(`/api/credit/tokens/${tokenId}`, { token });

         const tokens = this.state.tokens.map(t => {
            if (t._id === tokenId)
               return res.data;
            return t;
         });

         this.setState({ tokens });
         this.closeAddTokenMenu();

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }

   }

   sendToken = async (token) => {

      try {

         showLoading();

         const tokenId = token._id;
         const res = await request.post(`/api/credit/tokens/${tokenId}/send`);

         const tokens = this.state.tokens.map(t => {
            if (t._id === tokenId)
               return res.data;
            return t;
         });

         this.setState({ tokens });
         swal('Success', 'Token sent successfully', 'success');

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }


   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.tokens)
         await this.fetchTokens();
   }

   render() {
      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'token',
                  caption: 'Token',
                  render: (token) => token ? <PillLabel>
                     {token}
                  </PillLabel> : '–'
               },
               {
                  field: 'days',
                  caption: 'Days',
                  rightAlign: true,
               },
               {
                  field: 'sent',
                  caption: 'Sent',
                  render: sent => sent ? <span className="text-green-600">YES</span> : <span className="text-red-600">NO</span>
               },
               {
                  field: 'customer',
                  caption: 'Customer',
                  render: customer => customer ? <StyledLink to={links.customer(customer._id)}>
                     {customer.name} {customer.surname}
                  </StyledLink> : '–'
               },
               {
                  field: 'installation',
                  caption: 'Installation',
                  render: installation => <StyledLink to={links.installation(installation._id)}>
                     View Installation
                  </StyledLink>
               },
               {
                  field: 'created_at',
                  caption: 'Created at',
                  render: created_at => created_at ? <DateTime value={created_at} /> : '–'
               },
               {
                  field: 'actions',
                  caption: 'Actions',
                  render: (_, row) => {

                     const canUpdate = hasIntersection(this.props.roles, [USER_ROLE.SUPER_ADMIN, USER_ROLE.CREDIT_MANAGER]);

                     return row.token ? <Button
                        size="small"
                        startIcon={<SendIcon />}
                        onClick={() => this.sendToken(row)}
                        disabled={!canUpdate}
                     >
                        SEND
                     </Button> : <Button
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={e => this.openAddTokenMenu(e.currentTarget, row)}
                        disabled={!canUpdate}
                     >
                        Token
                     </Button>
                  }
               }
            ]}
            rows={this.state.tokens}
            onRefresh={this.fetchTokens}
            pagination={{
               count: this.state.total,
               page: this.state.page,
               rowsPerPage: this.state.limit,
               labelRowsPerPage: 'Tokens per page',
               onPageChange: (_, page) => this.setState({ page }),
               onRowsPerPageChange: e => this.setState({ limit: e.target.value, page: 0 })
            }}
            fullHeight
            filters={{
               onChange: filters => this.setState({ filters, page: 0 }, this.fetchTokens),
               filters: [
                  {
                     field: 'sent',
                     label: 'Sent',
                     type: "boolean",
                     value: this.state.filters.sent,
                  },
                  {
                     field: 'generated',
                     label: 'Generated',
                     type: "boolean",
                     value: this.state.filters.generated,
                  },
                  {
                     field: 'from',
                     label: 'From',
                     type: "date",
                     value: this.state.filters.from,
                  },
                  {
                     field: 'to',
                     label: 'To',
                     type: "date",
                     value: this.state.filters.to,
                  }
               ]
            }}
         />
         {
            this.state.addTokenMenuAnchor && <Menu
               anchorEl={this.state.addTokenMenuAnchor}
               open
               onClose={() => this.closeAddTokenMenu()}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
               }}
            >
               <div className="p-4">
                  <div className="grid grid-cols-[200px,auto] rounded-md border-[1px] border-orange-600 overflow-hidden">
                     <input
                        id="txt-token"
                        placeholder="Token"
                        className="p-2 rounded-none outline-none"
                     />
                     <Button
                        variant="contained"
                        size="small"
                        className="rounded-none"
                        onClick={this.submitToken}
                     >
                        <SendIcon fontSize="small" />
                     </Button>
                  </div>
               </div>
            </Menu>
         }
      </>   
   }
}

const mapStateToProps = state => ({
   roles: state.user?.roles || []
});

const Tokens = connect(mapStateToProps)(_Tokens);

export default Tokens;